export default __webpack_public_path__ + "static/media/gallery-3-4.85917651.webp";